import { useState, useRef } from "react";
import { HiVolumeUp, HiVolumeOff } from "react-icons/hi";

const VIDEO_URL =
  "https://res.cloudinary.com/dqxlte6wf/video/upload/q_auto,f_auto/v1773052380/atqkrwyxaurhsqwbomro";

function HeroVideo() {
  const [play, setPlay] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [muted, setMuted] = useState(true);

  const videoRef = useRef(null);

  const isDesktop = () => window.innerWidth >= 1024;

  const playInline = () => {
    setPlay(true);
    setTimeout(() => videoRef.current?.play(), 50);
  };

  const playExpanded = (e) => {
    e.stopPropagation();

    if (isDesktop()) {
      setExpanded(true);
    }

    setPlay(true);
    toggleMute();
    setTimeout(() => videoRef.current?.play(), 200);
  };

  const toggleMute = () => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = !video.muted;
    setMuted(video.muted);
  };

  return (
    <div
      onMouseEnter={() => play && setExpanded(true)}
      onMouseLeave={() => play && setExpanded(false)}
      className={`relative w-full lg:w-[420px] self-end rounded-lg border-[5px] origin-bottom-right border-white overflow-hidden shadow-lg transition-all duration-500 ${expanded ? "lg:w-[520px]" : ""
        }`}
      style={{
        aspectRatio: "16 / 9",
        boxShadow: "0 8px 30px rgba(0,0,0,0.5)",
      }}
    >
      {/* Video */}
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover z-0"
        src={VIDEO_URL}
        autoPlay
        muted={muted}
        controls
        loop
        playsInline
        preload="metadata"
      />

      {/* Thumbnail */}
      {!play && (
        <div
          className="absolute inset-0 z-10 cursor-pointer"
          onClick={playInline}
        >
          <img
            src={`${VIDEO_URL}.jpg`}
            alt="video thumbnail"
            className="w-full h-full object-cover"
          />

          {/* Play Button */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div
              onClick={playExpanded}
              className="w-14 h-14 rounded-full flex items-center justify-center cursor-pointer transition-transform hover:scale-110"
              style={{
                background: "rgba(255,255,255,0.95)",
                boxShadow: "0 4px 16px rgba(0,0,0,0.4)",
              }}
            >
              <div
                style={{
                  width: 0,
                  height: 0,
                  borderTop: "8px solid transparent",
                  borderBottom: "8px solid transparent",
                  borderLeft: "14px solid #1a1f3a",
                  marginLeft: "4px",
                }}
              />
            </div>
          </div>
        </div>
      )}

      {/* Mute Button */}
      {play && (
        <button
          onClick={toggleMute}
          className="absolute bottom-3 right-3 z-20 w-9 h-9 flex items-center justify-center rounded-full bg-black/70 text-white hover:bg-black/90 transition-colors"
        >
          {muted ? <HiVolumeOff size={18} /> : <HiVolumeUp size={18} />}
        </button>
      )}
    </div>
  );
}

export default HeroVideo;
